import { create } from "zustand";

import pureStore from "./pureStore";

const useGrandStore = create(pureStore);

export default useGrandStore;
